const ORDER_ROUTES = {
  create: 'orders',
}

export default ORDER_ROUTES
